import { Container, makeStyles, Typography } from "@material-ui/core";

export const NoResultsFound = ({ query, filterApplied }: any) => {
  const classes = useStyles();

  if (query === "" && !filterApplied) {
    return (
      <Container className={classes.noRecordsFound}>
        <Typography variant="body1" component="span">
          No records found
        </Typography>
      </Container>
    );
  } else {
    if (filterApplied) {
      return (
        <Container className={classes.noSearchResults}>
          <Typography variant="h6" component="span" color="textPrimary">
            0 search results found
          </Typography>
          <Typography variant="body2" component="span" color="textSecondary">
            Adjust your filtering and try again
          </Typography>
        </Container>
      );
    } else {
      return (
        <Container className={classes.noSearchResults}>
          <Typography variant="h6" component="span" color="textPrimary">
            0 search results found
          </Typography>
          <Typography variant="body2" component="span" color="textSecondary">
            Adjust your search term and try again
          </Typography>
        </Container>
      );
    }
  }
};
const useStyles = makeStyles({
  noRecordsFound: {
    display: "flex",
    paddingLeft: "24px",
    flexDirection: "column",
  },
  noSearchResults: {
    display: "flex",
    paddingLeft: 24,
    paddingTop: 40,
    flexDirection: "column",
  },
});
